angular.module("app").controller("GamesCategoriesAndProvidersPageController", [
    '$scope',
    '$uibModal',
    'preloadedSkins',
    'hiddenGamesService',
    'iconsService',
    'errorHandler',
    'logger',
    'pagination',
    'userStorage',
    function ($scope, $modal, preloadedSkins, hiddenGamesService, iconsService ,errorHandler, logger, pagination, userStorage) {
        $scope.filterOptions = {
            skinId: null,
            categoriesSearch: null,
            providersSearch: null
        };

        $scope.labelColumnContainer = {
            column: "providerTitle",
            field: "badge"
        };

        $scope.categoryLabelColumnContainer = {
            column: "categoryTitle",
            field: "badge"
        };

        preloadedSkins.unshift({name: "Select skin", id: null});

        $scope.hasPermission = userStorage.getUserData().permissions.indexOf('manageCategoriesProviders') !== -1;

        $scope.skins = angular.copy(preloadedSkins);
        $scope.tournamentStatus = null;

        $scope.getCategoriesAndProviders = function (skinId) {
            if (!!skinId) {
                $scope.filterOptions.skinId = skinId;
                return getItems(skinId)
            }

            $scope.categories = [];
            $scope.providers = [];
            $scope.filterOptions.skinId = null;
            $scope.tournamentStatus = null;
            $scope.categoriesPagination.totalItems = 0;
            $scope.providersPagination.totalItems = 0;

        };
        $scope.categories = [];
        $scope.providers = [];
        var limits = [{value: 5}, {value: 10}, {value: 25}, {value: 50}, {value: 100}];
        $scope.providersPagination = pagination.init(function () {
            $scope.selectProviders({
                current_page: $scope.providersPagination.page,
                limit: $scope.providersPagination.limit
            });
        }, parseInt($scope.providers.length), 25, undefined, undefined, limits);
        $scope.categoriesPagination = pagination.init(function () {
            $scope.selectCategories({
                current_page: $scope.categoriesPagination.page,
                limit: $scope.categoriesPagination.limit
            });
        }, parseInt($scope.categories.length), 25, undefined, undefined, limits);

        function getItems(skinId) {

            hiddenGamesService.getProvidersBySkinId({skin_id: skinId}).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.allProviders = angular.copy(response.items.map(function (value) {
                            value.hidden = !value.hidden;
                            value.justice = value.justice === "1";
                            return value
                        }));
                        $scope.providersPagination.totalItems = $scope.allProviders.length;
                        $scope.providersPagination.page = 1;
                        $scope.selectProviders({
                            current_page: $scope.providersPagination.page,
                            limit: $scope.providersPagination.limit
                        });
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            );

            hiddenGamesService.getCategoriesBySkinId({skin_id: skinId}).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.allCategories = angular.copy(response.items).map(extractCategory);

                        // $scope.allCategories = angular.copy(response.items.map(function (value) {
                        //     value.hidden = !value.hidden;
                        //     return value
                        // }));
                        $scope.categoriesPagination.totalItems = $scope.allCategories.length;
                        $scope.categoriesPagination.page = 1;
                        $scope.selectCategories({
                            current_page: $scope.categoriesPagination.page,
                            limit: $scope.categoriesPagination.limit
                        });
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            );

            hiddenGamesService.getTournamentEnabledStatus({skin_id: skinId}).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.tournamentStatus = angular.copy(response.is_enabled);
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        }

        $scope.switchTournamentStatus = function () {
            var requestData = {
                skin_id: $scope.filterOptions.skinId,
                is_enabled: $scope.tournamentStatus
            };

            hiddenGamesService.updateTournamentStatus(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess('global.successfullyUpdated')
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            );
        };

        function changeLabel(item, type) {
            $modal.open({
                templateUrl: "views/pageBuilders/skillGames/gameLabel.html",
                controller: "GamesLabelPopupController",
                resolve: {
                    initialLabel: function () {
                        return item.badge;
                    }
                }
            }).result.then(function (res) {
                if (type === 'provider') {
                    service = hiddenGamesService.changeLabel({
                        id: item.id,
                        badge: res
                    })
                } else {
                    service = hiddenGamesService.changeCategoryLabel({
                        id: item.skin_category_id,
                        badge: res
                    })
                }
                service.then(function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess('global.successfullyUpdated');
                            item.badge = res;
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    });
            });
        }

        function extractCategory(category) {
            return {
                id: category.category_id,
                skin_category_id: category.id,
                icon: category.icon,
                icon_src: category.icon_src,
                categoryTitle: category.categoryTitle,
                disabled: category.disabled,
                hidden: !category.hidden,
                badge: category.badge,
            }
        }

        $scope.changeTheValue = function (item, isProvider) {
            var fn = hiddenGamesService["update" + (isProvider ? 'Provider' : 'Category')],
                requestData = {
                    visibility: {
                        id: isProvider ? item.id : item.skin_category_id,
                        hidden: !item.hidden
                    }
                };
            fn(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess('global.successfullyUpdated')
                    } else {
                        item.hidden = !item.hidden;
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    item.hidden = !item.hidden;
                    errorHandler(response.message)
                }
            );
        };
        if ($scope.hasPermission) {
            $scope.allowUpdateProvidersContainer = {};
            $scope.allowUpdateProvidersContainer.allowUpdate = function (options) {
                if ($scope.filterOptions.providersSearch) {
                    logger.logError("When you search something you can't reorder");
                    return;
                }
                if (options && options.autoUpdate) {
                    var endIndex = ($scope.providersPagination.page - 1) * $scope.providersPagination.limit + $scope.providersPagination.limit;
                    var j = 0;
                    for (var i = ($scope.providersPagination.page - 1) * $scope.providersPagination.limit; i < endIndex; ++i) {
                        if ($scope.allProviders[i]) {
                            $scope.allProviders[i] = $scope.providers[j++];
                        } else {
                            break;
                        }
                    }
                    reorder($scope.allProviders, hiddenGamesService.changeProviderOrder);
                } else if (!!options) {
                    $scope.tabOptions.reorderedProviders = true
                }
            };
        }

        $scope.ignoreColumnsCategories = {
            'hidden': true,
            'skin_category_id': true,
            'order': true,
            'provider': true,
            'skin_id': true,
            'categoryName': true,
            'category_id': true,
            'badge': true,
            'justice': true,
            'icon': true,
            'hasJustice': true,
        };

        $scope.ignoreColumnsProviders = {
            'hidden': true,
            'skin_category_id': true,
            'order': true,
            'provider': true,
            'skin_id': true,
            'categoryName': true,
            'category_id': true,
            'badge': true,
            'justice': true,
            'icon': true,
            'icon_src': true,
            'hasJustice': true,
        };

        var iconsCategory = [4] // casino

        $scope.addIcon = function (category) {
            $modal.open({
                templateUrl: "views/filters/addIcon.html",
                controller: "FiltersAddIconPageController",
                resolve: {
                    preloadedIcons: function (iconsService, errorHandler) {
                        return iconsService.getIconsList(iconsCategory).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response);
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    iconsCategory: function () {
                        return iconsCategory
                    },
                    selectedIcon: function () {
                        return {icon :category.icon, icon_src: category.icon_src};
                    }
                },
            }).result.then(function (icon) {
                hiddenGamesService.changeIconSkinCategory({
                    id: category.skin_category_id,
                    icon: icon.name
                }).then(function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess('global.successfullyUpdated');
                            category.icon = icon.name;
                            category.icon_src = icon.src;
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    });
            });
        };

        $scope.categoriesTools = {
            "switch": {
                name: function (item) {
                    return 'hiddenGames' + item.categoryName;
                },
                model: function () {
                    return "hidden";
                },
                change: function (item) {
                    $scope.changeTheValue(item);
                },
                disabled: !$scope.hasPermission
            },
            "changeLabel": {
                title: function () {
                    return "Change Badge"
                },
                class: function () {
                    return "category-label animated bounceIn";
                },
                action: function (item) {
                    changeLabel(item, 'category');
                }
            },
            addIcon: {
                action: function (item) {
                    $scope.addIcon(item)
                },
                class: function () {
                    return "plus";
                },
                title: function () {
                    return "Add Icon";
                }
            },
        };

        function changeJustice(item) {
            hiddenGamesService.changeJustice({
                justice: {
                    id: item.id,
                    hidden: item.justice
                }
            }).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess('global.successfullyUpdated')
                    } else {
                        item.justice = !item.justice;
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    item.justice = !item.justice;
                    errorHandler(response.message)
                }
            );
        }

        $scope.providersTools = {
            "checkbox": {
                name: function (item) {
                    return "Promoted";
                },
                model: function () {
                    return "justice";
                },
                change: changeJustice,
                visible: function (item) {
                    return !!item.hasJustice;
                }
            },
            "switch": {
                name: function (item) {
                    return 'hiddenGames' + item.providerTitle;
                },
                model: function () {
                    return "hidden";
                },
                change: function (item) {
                    $scope.changeTheValue(item, true);
                },
                disabled: !$scope.hasPermission
            },
            "changeLabel": {
                title: function () {
                    return "Change Badge"
                },
                class: function () {
                    return "category-label animated bounceIn";
                },
                action: function (item) {
                    changeLabel(item, 'provider');
                }
            }
        };
        if ($scope.hasPermission) {
            $scope.allowUpdateCategoriesContainer = {};
            $scope.allowUpdateCategoriesContainer.allowUpdate = function (options) {
                if ($scope.filterOptions.categoriesSearch) {
                    logger.logError("When you search something you can't reorder");
                    return;
                }
                if (options && options.autoUpdate) {
                    var endIndex = ($scope.categoriesPagination.page - 1) * $scope.categoriesPagination.limit + $scope.categoriesPagination.limit;
                    var j = 0;
                    for (var i = ($scope.categoriesPagination.page - 1) * $scope.categoriesPagination.limit; i < endIndex; ++i) {
                        if ($scope.allCategories[i]) {
                            $scope.allCategories[i] = $scope.categories[j++];
                        } else {
                            break;
                        }

                    }
                    reorder($scope.allCategories, hiddenGamesService.changeCategoryOrder, 'skin_category_id');
                } else if (!!options) {
                    $scope.tabOptions.reorderedCategories = true
                }
            };
        }


        function reorder(listOfValues, serviceFunction, field = 'id') {
            if (typeof listOfValues === "object" && listOfValues.length) {
                var list = [];

                listOfValues.forEach(function (item) {
                    list.push(item[field])
                });
                serviceFunction({order: list}).then(
                    function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("global.updated")
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            }
        }

        $scope.selectProviders = function (request) {
            if ($scope.filterOptions.providersSearch !== null) {
                $scope.providers = $scope.allProviders.filter(function (item) {
                    return item.providerTitle.toLowerCase().indexOf($scope.filterOptions.providersSearch.toLowerCase()) !== -1;
                });
            } else {
                $scope.providers = $scope.allProviders;
            }
            $scope.providersPagination.totalItems = $scope.providers.length;

            $scope.providers = $scope.providers.slice((request.current_page - 1) * request.limit, (request.current_page - 1) * request.limit + request.limit);

        };

        $scope.selectCategories = function (request) {
            if ($scope.filterOptions.categoriesSearch !== null) {
                $scope.categories = $scope.allCategories.filter(function (item) {
                    return (
                        item.categoryTitle.toLowerCase().indexOf($scope.filterOptions.categoriesSearch.toLowerCase()) !== -1 ||
                        item.id.indexOf($scope.filterOptions.categoriesSearch) !== -1
                    );
                });
            } else {
                $scope.categories = $scope.allCategories;
            }
            $scope.categoriesPagination.totalItems = $scope.categories.length;
            $scope.categories = $scope.categories.slice((request.current_page - 1) * request.limit, (request.current_page - 1) * request.limit + request.limit);
        };

        $scope.categoriesListFilterObject = {
            action: function () {
                $scope.selectCategories({
                    current_page: $scope.categoriesPagination.page,
                    limit: $scope.categoriesPagination.limit
                });
            }
        };
        $scope.providersListFilterObject = {
            action: function () {
                $scope.selectProviders({
                    current_page: $scope.providersPagination.page,
                    limit: $scope.providersPagination.limit
                });
            }
        };
    }
]);
